import {Skeleton} from '@gwc/core'
import {Box, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {InputSkeleton} from './components/InputSkeleton/index@desktop'
import * as classes from './LayoutSkeleton@desktop.classes'

export const LayoutSkeleton = memo(
  (): React.ReactElement => (
    <Box flexDirection="column">
      <Paper className={classes.paper.filler} radius="L" noOverflow>
        <Skeleton className={classes.skeleton.filler} my="s" />
      </Paper>
      <div className={classes.paperWrapper}>
        <Paper className={classes.paper.widget} radius="L" noOverflow>
          <Skeleton className={classes.skeleton.header} />
          <Box className={classes.inputs} flexDirection={'column'}>
            <InputSkeleton />
            <InputSkeleton />
          </Box>
        </Paper>
      </div>
      <div className={classes.paperWrapper}>
        <Paper className={classes.paper.widget} radius="L" noOverflow>
          <Skeleton className={classes.skeleton.header} />
          <Box className={classes.inputs} flexDirection={'column'}>
            <InputSkeleton />
            <InputSkeleton />
          </Box>
        </Paper>
      </div>
      <div className={classes.paperWrapper}>
        <Paper className={classes.paper.widget} radius="L" noOverflow>
          <Skeleton className={classes.skeleton.header} />
          <Box className={classes.inputs} flexDirection={'column'}>
            <InputSkeleton />
          </Box>
        </Paper>
      </div>
      <div className={classes.paperWrapper}>
        <Paper className={classes.paper.widget} radius="L" noOverflow>
          <Skeleton className={classes.skeleton.header} />
          <Box alignItems={'center'} className={classes.wrapper.content} justifyContent={'flex-end'}>
            <Box className={classes.wrapper.options} flexDirection={'column'}>
              <Skeleton className={classes.skeleton.option} />
              <Skeleton className={classes.skeleton.option} />
              <Skeleton className={classes.skeleton.option} />
            </Box>
          </Box>
        </Paper>
      </div>
      <div className={classes.paperWrapper}>
        <Paper className={classes.paper.widget} radius="L" noOverflow>
          <Box alignItems={'center'} className={classes.wrapper.payment} justifyContent={'space-between'}>
            <Skeleton className={classes.skeleton.header} />
            <Skeleton className={classes.skeleton.header} />
            <Skeleton className={classes.skeleton.button} />
          </Box>
        </Paper>
      </div>
    </Box>
  ),
)
